import React from "react";
import logo from "assets/img/logo/logo_aig_login.png";
import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import { Textbox, Checkbox } from "react-inputs-validation";

import Page from "components/Page";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import {
  FetchModificarCarrito,
  limpiarDatosValidacionesPlaca,
} from "../../../redux/actions/ACarritoProductos";
import { setConsultaPlaca } from "../../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import { async } from "q";

class ValoresCotizacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vigencia: "",
    };
    this.validateForm = this.validateForm.bind(this);
  }

  editarForm = (formEditado) => {
    this.setState({ formEditado });
  };
  onEditar = (e) => {
    e.preventDefault();
    //console.log(this.props)
    this.props.limpiarDatosValidacionesPlaca();
    console.clear();
    console.log('this.props.codigoProductoEspecial', this.props.codigoProductoEspecial)
    this.props.setDatosPlaca(this.props.datosCotizacion.datosProducto);
    this.props.history.push({
      pathname: "/datos-cotizacion",
      search: `?accion=editar&placa=${this.props.datosCotizacion.datosProducto.placa}${this.props.codigoProductoEspecial != null ? "&codigoProductoEspecial=" + this.props.codigoProductoEspecial : ""}`,
    });
  };
  returnVigencia = () => {
    const arrayKM =
      this.props.datosCotizacion && this.props.datosCotizacion.PlanesKmPaquete
        ? this.props.datosCotizacion.PlanesKmPaquete
        : [];
    const plan =
      this.props.datosCotizacion &&
        this.props.datosCotizacion.datosCalculoScoring &&
        this.props.datosCotizacion.datosCalculoScoring.plan
        ? this.props.datosCotizacion.datosCalculoScoring.plan
        : "";
    console.log(arrayKM);
    if (arrayKM.length > 0) {
      arrayKM.forEach((element) => {
        if (element.plan === plan) {
          this.setState({ vigencia: element.vigenciaDias });
        }
      });
    }
    console.log(this.state.vigencia);
  };

  onEliminar = async (e) => {
    e.preventDefault();
    //console.log(this.props)

    //Agregar array de Amparos Adicionales
    const ValorAmparosAdicionales = {
      gastosMedicos: "3000",
      accidentesPersonales: "5000",
      gastosTransporte: "0",
      amparoPatrimonial: "0",
      objetosOlvidados: "0",
      gastosFunerarios: "0",
      amparoSustituto: "Basic",
      llaveProtegida: "150",
      documentosProtegidos: "100",
    };

    const dataEliminar = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      cliCodigoCore: this.props.detalleCarrito.productosCarrito.cliCodigoCore,
      datosProducto: this.props.datosCotizacion.datosProducto,
      datosCliente: this.props.datosCotizacion.datosCliente,
      datosCoberturas: [],
      datosAmparos: [],
      placa: this.props.datosCotizacion.datosProducto.placa,
      accion: "eliminar",
      carCodigo: this.props.detalleCarrito.productosCarrito.idCarrito,
      datosAsesor: {
        nombre: `${this.props.datosUsuarios.nombres} ${this.props.datosUsuarios.apellidos}`,
        codigoCore: this.props.datosUsuarios.cliCodigoCore,
        sucursalSeleccionada: this.props.datosSucursales
          .sucursalSelecionadaAsesor,
      },
      esCotizacion: false,
      amparosAdicionales: ValorAmparosAdicionales,
    };
    await this.props.eliminarProducto(dataEliminar);
    //const datosCarritoJSON=JSON.stringify(dataEliminar);
    //console.log("Enviar carrtio",datosCarritoJSON)
    //debugger
    this.props.metodoEliminar();


    if (this.props.cuentaCarrito === "" || this.props.cuentaCarrito === "0" || this.props.cuentaCarrito === 0 || this.props.cuentaCarrito === undefined || (this.props.detalleCarrito.productosCarrito.carProductos.length - 1) === 0) {
      // this.props.history.replace({
      //   pathname: `/`
      // });

      var search = `?accion=eliminar`

      if (this.props.codigoProductoEspecial == 'comparador') {

        search = '?accion=eliminar&codigoProductoEspecial=comparador'

      }
      this.props.history.push({
        pathname: "/cotizacion",
        search: search

      });

    }

  };

  componentDidUpdate() {
    /*if(this.prevProps!== undefined && this.props !== undefined && this.props.cuentaCarrito !== this.prevProps.cuentaCarrito)
      {*/
    if (
      this.props.cuentaCarrito === "" ||
      this.props.cuentaCarrito === "0" ||
      this.props.cuentaCarrito === 0 ||
      this.props.cuentaCarrito === undefined
    ) {
      this.props.history.replace({
        pathname: `/`,
      });
    }
    //}
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError,
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }

  onClick = (event) => {
    //console.log("Entre a evento onCLik")
    event.preventDefault();
    if (this.props.paso === "datos-cotizacion") {
      this.props.metodo();
    }
  };
  componentDidMount() {
    this.returnVigencia();
    console.log('listadoProducto', this.props);
  }

  render() {
    let { detalleCarrito, formEditado, datosCotizacion, indice } = this.props;
    //console.log("Cambiando estado boton ",formEditado,Object.keys(detalleCarrito.productosCarrito).length)
    //const{formEditado}=this.state;
    // console.log("INDICEEEEE ",indice)
    indice = parseInt(indice) + 1;
    let total =
      Object.keys(detalleCarrito.productosCarrito).length === 0
        ? "0.00"
        : detalleCarrito.productosCarrito.carProductos[0].totales;
    if (total === "0.00") {
      total = {
        prima_neta_anual_full_cobertura: "0.00",
        super_bancos_Full_Cobertura: "0.00",
        seguro_campesino_Full_Cobertura: "0.00",
        derecho_emision_Full_Cobertura: "0.00",
        primaTotal_Full_Cobertura: "0.00",
        iva_Full_Cobertura: "0.00",
        totalImpuestos: "0.00",
      };
    }

    //Cargar ArrayColores
    let ObtenerColor = "";
    let NombreColor = "";
    if (
      datosCotizacion.datosProducto !== undefined &&
      datosCotizacion.datosProducto.color !== undefined &&
      datosCotizacion.datosProducto.color !== "" &&
      this.props.catalogoCotizacion &&
      this.props.catalogoCotizacion
    ) {
      ObtenerColor = this.props.catalogoCotizacion.colores.filter(
        (arrayColor) =>
          arrayColor.colCodigoCore ===
          parseInt(datosCotizacion.datosProducto.color)
      );
      NombreColor = ObtenerColor[0].colNombre;
    }

    //console.log("CIIIIIII",NombreColor);

    return (
      <Card className="flex-row ">
        <CardBody>
          <h4 style={{ fontWeight: "bold" }}> {`Vehículo ${indice}`}</h4>
          <p></p>
          {((this.props.ProductoEspecial !== undefined &&
            this.props.ProductoEspecial) ||
            this.props.origen === "final-cotizacion") && (
              <div>
                {this.props.datosCotizacion &&
                  this.props.datosCotizacion.datosCalculoScoring &&
                  this.props.datosCotizacion.datosCalculoScoring.plan && (
                    <div>


                      <Row>
                        <Col sm={6} md={6}><p>Cédula:</p></Col>
                        <Col sm={6} md={6}><p>{datosCotizacion.datosCliente ? datosCotizacion.datosCliente.cedula : ''}</p></Col>
                      </Row>
                      <Row>
                        <Col sm={6} md={6}><p>Nombre:</p></Col>
                        <Col sm={6} md={6}><p>{datosCotizacion.datosCliente ? datosCotizacion.datosCliente.nombre : ''}</p></Col>
                      </Row>

                      <hr></hr>

                      <Row>
                        <Col sm={6} md={6}><p>Plan Seleccionado:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>{this.props.datosCotizacion &&
                          this.props.datosCotizacion.datosCalculoScoring &&
                          this.props.datosCotizacion.datosCalculoScoring.planTexto
                          ? this.props.datosCotizacion.datosCalculoScoring
                            .planTexto
                          : ""}</p></Col>
                      </Row>

                      <Row>
                        <Col sm={6} md={6}><p>Descripción:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                            this.props.detalleCarrito &&
                            this.props.detalleCarrito.productosCarrito &&
                            this.props.detalleCarrito.productosCarrito.carDescripcionSeguro
                            ? this.props.detalleCarrito.productosCarrito.carDescripcionSeguro != 'PITS' ? this.props.detalleCarrito.productosCarrito.carDescripcionSeguro : 'PractiAuto'
                            : ""
                          }</p></Col>
                      </Row>

                      <Row>
                        <Col sm={6} md={6}><p>Marca:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                           datosCotizacion.datosProducto ? datosCotizacion.datosProducto.marca : ''
                          }</p></Col>
                      </Row>

                      <Row>
                        <Col sm={6} md={6}><p>Modelo:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                          datosCotizacion.datosProducto ? datosCotizacion.datosProducto.modelo : ''
                          }</p></Col>
                      </Row>


                      <Row>
                        <Col sm={6} md={6}><p>Año:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                         datosCotizacion.datosProducto ? datosCotizacion.datosProducto.anio : ''
                          }</p></Col>
                      </Row>

                      <Row>
                        <Col sm={6} md={6}><p>Prima Total:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                         `$${datosCotizacion.totales.primaTotal_Full_Cobertura}`
                          }</p></Col>
                      </Row>
                      
                      <Row>
                        <Col sm={6} md={6}><p>Placa:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                         datosCotizacion.datosProducto ? datosCotizacion.datosProducto.placa : ''
                          }</p></Col>
                      </Row>

                      <Row>
                        <Col sm={6} md={6}><p>Valor Asegurado:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                       `$${datosCotizacion.datosProducto ? datosCotizacion.datosProducto.valorAsegurado : '0'}`
                          }</p></Col>
                      </Row>

                      <Row>
                        <Col sm={6} md={6}><p>Color:</p></Col>
                        <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>
                          {
                       NombreColor
                          }</p></Col>
                      </Row>
                  

                    </div>)}
              </div>
            )}
      
       
          
         
          <Row>
         
         
           
         
          </Row>
       
         
        
          {this.props.origen === "resumen-cotizacion" && (
            <Row>
              <div className="div-align-rigth">
                <Button className="btn btn-detail-gray" onClick={this.onEditar}>
                  <i className="fa fa-pencil-square-o" aria-hidden="true" />{" "}
                  EDITAR
                </Button>
                &nbsp;&nbsp;
                <Button
                  className="btn btn-detail-white"
                  onClick={this.onEliminar}
                >
                  <i className="fa fa-trash-o" aria-hidden="true" /> ELIMINAR
                </Button>
              </div>
            </Row>
          )}
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  detalleCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  cuentaCarrito: state.countCarrito,
  datosSucursales: state.datosSucursales,
  catalogoCotizacion: state.catalogosCotizacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    eliminarProducto: (data) => dispatch(FetchModificarCarrito(data)),
    limpiarDatosValidacionesPlaca: () =>
      dispatch(limpiarDatosValidacionesPlaca()),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ValoresCotizacion)
);
